<template>
  <SharedNavigation>
    <b-nav-item
      :to="{ name: 'dashboard' }"
      class="d-none d-lg-flex"
    >
      <span>Dashboard</span>
    </b-nav-item>

    <b-nav-item-dropdown
      text="Profiles"
      class="d-none d-lg-flex"
      :toggle-class="{ active: isChildrenRoute() }"
    >

      <b-dropdown-item
        :to="{ name: 'children' }"
      >
        Children
      </b-dropdown-item>

    </b-nav-item-dropdown>

    <b-nav-item
      :to="{ name: 'team-schedule' }"
      class="d-none d-lg-flex"
    >
      <span>My schedule</span>
    </b-nav-item>

    <template #search>
      <HeaderSearch
        @search="search($event)"
      />
    </template>

  </SharedNavigation>
</template>

<script>
import { mapGetters } from 'vuex'
import SharedNavigation from '@/core/layouts/global-layout/components/user-navigation/SharedNavigation'
import { isBookingsRoute, isChildrenRoute } from '@/core/router/utils'
import HeaderSearch from '@/core/layouts/global-layout/components/nav-items/HeaderSearch'

export default {
  components: {
    SharedNavigation,
    HeaderSearch
  },

  computed: {
    ...mapGetters('auth', ['userIsSessionalStaff']),
  },

  methods: {
    isBookingsRoute() {
      return isBookingsRoute(this.$route.name)
    },

    isChildrenRoute() {
      return isChildrenRoute(this.$route.name)
    },

    search(event) {
      this.$emit('search', event)
    },
  }
}
</script>
